import { createSlice } from '@reduxjs/toolkit';
import { emptyFetchState } from '../emptyState';
import { fetchStatus } from '../status';
import { getPublisherResources } from 'api';

// Then, handle actions in your reducers:
const publisherResourcesSlice = createSlice({
  name: 'publisherResources',
  emptyFetchState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    publisherResourcesFetchStart: (state) => {
      state.status = fetchStatus.FETCH_START;
      state.fetching = true;
    },
    publisherResourcesFetchSuccess: (state, { payload }) => {
      state.status = fetchStatus.FETCH_SUCCESS;
      state.payload = payload;
      state.fetching = false;
    },
    publisherResourcesFetchFail: (state, { payload }) => {
      state.status = fetchStatus.FETCH_FAIL;
      state.payload = payload;
      state.fetching = false;
      state.error = true;
    },
    publisherResourcesResetState: (state) => {
      state.payload = null;
      state.fetching = false;
    },
  },
});

// actions generated from the slice, TODO: remove start,success,fail
export const {
  publisherResourcesFetchStart,
  publisherResourcesFetchSuccess,
  publisherResourcesFetchFail,
  publisherResourcesResetState,
} = publisherResourcesSlice.actions;

// The reducer
export const publisherResourcesReducer = publisherResourcesSlice.reducer;

// Asynchronous thunk action
export const publisherResourcesFetch = (id: string) => (dispatch) => {
  dispatch(publisherResourcesFetchStart());

  getPublisherResources(id)
    .then((publisherResources) => {
      dispatch(publisherResourcesFetchSuccess(publisherResources.data));
    })
    .catch((error) => {
      dispatch(publisherResourcesFetchFail(error));
    });
};
